<template >
    <div class="single-product__gtl">
        <div class="single-product__gtl__container">
            <div class="single-product__gtl__hotspot">
                <h4 class="single-product__gtl__title mb">get the look you deserve</h4>
                <div class="single-product__gtl__hotspot-wrap">
                    <div>
                        <img :src="data.image_thumbnail || data.image_url" :data-orignal_src="data.image_url" :alt="data.alt ?? ''" class="single-product__gtl__hotspot-image">
                        <div v-for="(point, key) in data.points" :key="key" class="">
                            <div @click="showActive(Number(key))" @mouseover="toggleActive(true, Number(key))" @mouseleave="toggleActive(false, Number(key))" class="single-product__gtl__point" :class="`single-product__gtl__popup-${point.popup}`" :style="{ top: point.y + '%',  left: point.x + '%'}">
                                <img src="/single-product/point_icon.webp" alt="" class="gtl-animation-zizo">
                                <div class="single-product__gtl__icon"></div>
                                <div class="single-product__gtl__product-popup">
                                    <p class="single-product__gtl__product-title">{{ point.product?.title }}</p>
                                    <!-- <p class="gtl-section__product-price price"> <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>{{ point.product?.price }}</bdi></span></p> -->
                                    <!-- <p class="gtl-section__product-price price" v-html="displayPriceHtml(point.product?.price, point.product?.regular_price, point.product?.sale_price)">
                                    </p> -->
                                    <p class="price-html" dir="ltr">
                                        <span class="w_price" v-if="point.product?.regular_price != '0'">
                                        <del v-if="point.product?.regular_price != '0' && Number(point.product?.sale_price) > 0 && Number(point.product?.regular_price) > Number(point.product?.sale_price)"><span class="woocommerce-Price-amount amount 99" v-html="displayCustomPrice(point.product?.regular_price)"></span></del>
                                        <ins v-if="Number(point.product?.sale_price) > 0 "><span class="woocommerce-Price-amount amount 44" v-html="displayCustomPrice(point.product?.sale_price)"></span></ins>
                                        <ins v-else><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(point.product?.regular_price)"></span></ins>
                                        </span>
                                        <span class="woocommerce-Price-amount amount" v-if="point.product?.regular_price == '0' " v-html="displayCustomPrice(point.product?.sale_price)"></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-product__gtl__component">
                <h4 class="single-product__gtl__title">get the look you deserve</h4>
                <div class="single-product__gtl__carousel splide">
                    <div class="single-product__gtl__carousel-track splide__track">
                        <div class="single-product__gtl__carousel-products splide__list">
                            <div
                                v-for="(product, index) in products"
                                :key="index"
                                class="single-product__gtl__carousel-product splide__slide"
                                :class="{ active: isActive(index) || isActiveHover[index] }"
                                >
                                
                                <div class="single-product__gtl__product-container">
                                    <div
                                    class="single-product__gtl__product-image "
                                    :class="product.thumbnail_hover_url ? 'has-hover-img' : ''">
                                    <a :href="getLangUrlItem(`${baseUrl.replace(/\/$/, '')}/${product.url.replace(/^\//, '')}`, baseUrl, locale)" class="">
                                        <img
                                        class="single-product__gtl__product-thumbnail alt-lazy-img"
                                        :src="`${baseUrl}api/wp-content/uploads/${ product.main_image_url_lazy || product.main_image_url}`"
                                        :data-orignal_src="`${baseUrl}api/wp-content/uploads/${product.main_image_url}`"
                                        :alt="product.alt ?? ''"
                                        />
                                        <img
                                        v-if="product.thumbnail_hover_url"
                                        class="single-product__gtl__product-thumbnail-hover alt-lazy-img"
                                        :src="`${baseUrl}api/wp-content/uploads/${ product.main_image_url_lazy || product.thumbnail_hover_url}`"
                                        :data-orignal_src="`${baseUrl}api/wp-content/uploads/${product.thumbnail_hover_url}`"
                                        :alt="product.alt ?? ''"
                                        />
                                    </a>
                                  <div class="product-tags product-tags-gtl" v-if="product.product_tag">
                                    <span
                                        v-for="(tag, index) in product.product_tag"
                                        :key="index"
                                        class="tag-item"
                                        :class="{ customise_tag_detail: product?.is_customise }"
                                        v-html="htmlSpecialcharsDecode(tag)">
                                    </span>
                                </div>
                                   

                                    </div>
                                    <p class="single-product__gtl__product-title">{{ product.title }}</p>
                                    <!-- <p>{{ product.regular_price }}</p> -->
                                    <p class="price-html" dir="ltr">
                                        <span class="w_price" v-if="product.regular_price != '0'">
                                        <del v-if="product.regular_price != '0' && Number(product.sale_price) > 0 && Number(product.regular_price) > Number(product.sale_price)"><span class="woocommerce-Price-amount amount 99" v-html="displayCustomPrice(product.regular_price)"></span></del>
                                        <ins v-if="Number(product.sale_price) > 0 "><span class="woocommerce-Price-amount amount 44" v-html="displayCustomPrice(product.sale_price)"></span></ins>
                                        <ins v-else><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(product.regular_price)"></span></ins>
                                        </span>
                                        <span class="sale-percent" v-if="Number(product.regular_price) > 0 && Number(product.sale_price) > 0 && Number(product.regular_price) > Number(product.sale_price)">
                                        <span v-if="Math.round(100 - (Number(product.sale_price) / Number(product.regular_price) * 100)) >= 5" :data-pecent="`-${Math.round(100 - (Number(product.sale_price) / Number(product.regular_price) * 100))}%`"></span>
                                        </span>
                                        <span class="woocommerce-Price-amount amount" v-if="product.regular_price == '0' " v-html="displayCustomPrice(product.sale_price)"></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_getthelook.scss";
</style>

<script setup lang="ts">
    import { onMounted } from "vue"
    import Splide from "@splidejs/splide"
    import { displayPriceHtml, displayCustomPrice } from "~/utils/displayPrice"
    const runtimeConfig = useRuntimeConfig();
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl, getLangUrlItem} from '~/utils/getLangUrl';
    
    interface ProductType{
        id: Number,
        title: string,
        price: string,
        regular_price: string,
        sale_price: string,
        main_image_url: string,
        thumbnail_hover_url: string,
        url: string,
        main_image_url_lazy: string,
        alt: string,
        product_tag: Array<string>,
    }
    interface MediaPoint {
        y: string;
        x: string;
        id: string;
        popup: string;
        product?: ProductType;
    }
    const baseUrl = runtimeConfig.public.BASE_URL;

    const props = defineProps<{
        data: {
            gtl_data: {
                points: { [key: string]: MediaPoint };
                image_url: string;
                image_thumbnail: string;
                alt:string;
            };
            products: ProductType[];
        }
    }>();

    const getTheLook = computed(() => props.data);
    const data = getTheLook.value.gtl_data;
    const products = getTheLook.value.products;

    const newPoints: { [key: number]: MediaPoint } = {};

    Object.keys(data.points).forEach((key) => {
        const point = data.points[key];
        const productIndex = products.findIndex((p: ProductType) => p.id === Number(point.id));
        if (productIndex !== -1) {
            const product = products[productIndex];
            newPoints[productIndex] = { ...point, product };
        }
    });

    data.points = newPoints;

    onMounted(() => {
        calculatePopupPosition();
        initGTLSplide();
        altLazyIO();
    })
    const activeKey = ref();
    const showActive = (key: number) => {
        if (window.innerWidth < 769) {
            activeKey.value = key;
        }
    };

    const isActive = (index: number) => {
        return activeKey.value === index;
    };
    const isActiveHover = ref<Record<number, boolean>>({});
    const toggleActive = (state: boolean, key: number) => {
        isActiveHover.value[key] = state;
    };
    const initGTLSplide = (): void => {
        const gtlCarousel = document.querySelector(".single-product__gtl__carousel") as HTMLElement | null;

        if (gtlCarousel && window.innerWidth <= 992) {
            const gtlSplide = new Splide(gtlCarousel, {
                perPage: 2,
                fixedWidth: '40%',
                perMove: 3,
                gap: '10px',
                arrows: false,
                pagination: false,
                drag: 'free',
                autoplay: false,
                interval: 5000,
                });
                gtlSplide.mount();
            }
        };

    const calculatePopupPosition = () => {
        const imageHotspot = document.querySelector<HTMLElement>('.single-product__gtl__hotspot-image');
        const points = document.querySelectorAll<HTMLElement>(".single-product__gtl__point");

        if (imageHotspot && points.length > 0) {
            points.forEach(point => {
                const popup = point.querySelector<HTMLElement>('.single-product__gtl__product-popup');

                if (popup) {
                    function calculatePosition() {
                        const rect = point.getBoundingClientRect();
                        const popupRect = popup!.getBoundingClientRect();
                        const imageRect = imageHotspot!.getBoundingClientRect();

                        const leftThreshold = rect.left - imageRect.left;

                        let left: number | undefined;
                        let right: number | undefined;

                        if (leftThreshold < 130) {
                            left = 130 - leftThreshold + 10;
                            popup!.style.left = `${left}px`;
                        }

                        if ((imageRect.right - rect.right) < 130) {
                            right = 130 + (imageRect.right - rect.right) - 10;
                            popup!.style.right = `-${right}px`;
                            popup!.style.left = 'unset';
                        }
                    }

                    point.addEventListener('mouseover', calculatePosition);
                    window.addEventListener('resize', calculatePosition);
                    window.addEventListener('scroll', calculatePosition);
                }
            });
        }
    };

</script>